import axios from "axios"
import config from "../config"
import Vue from "vue";
const moduleStore = {
    state: {
        userList: [],
    },
    mutations: {
    },
    actions: {
        async getSubCategoryList(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/getSubCategoryList`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async getSubCategoryDetail(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/getSubCategoryDetail`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async createSubCategory(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/createSubCategory`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async updateSubCategory(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/updateSubCategory`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async deleteSubCategory(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/deleteSubCategory`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async getCategoryList(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/getCategoryList`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
    },
    getters: {
    }
}

export default moduleStore;